<template>
  <v-container  ref="barWrapper" fluid fill-height  ma-0 pa-0 >
    <loading-circle
      :show="loader"
    />
    <v-layout fill-height>
      <scroll-table
        :data="getTable"
        :options="options"
        :sortable="false"
        :translate="false"
        :subscribed="true"
        :toolbar="'services'"
        @select=""
      />
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'

// Типы для данных
interface BrefItem {
  $id?: string
  ref?: string
  name?: string
  type?: string
  [key: string]: any
}

interface LocationConnectionsData {
  brefs?: BrefItem[]
  [key: string]: any
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
}

interface TableRow {
  name?: string
  type?: string
  $id?: string
  [key: string]: any
}

interface TableData {
  columns: TableColumn[]
  rows: TableRow[]
}

export default Vue.extend({
  name: 'LOCATION_CONNECTIONS_MODAL',

  components: {
    scrollTable,
    loadingCircle,
  },

  props: {
    data: {
      type: Object as () => LocationConnectionsData,
      default: () => ({})
    },
  },

  data(): {
    loader: boolean
    options: OptionsData
    filter: any | null
    search: string
    table: TableData
  } {
    return {
      loader: false,
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          endpoint: { width: '40%' },
          check: { width: '20%' },
        },
      },
      filter: null,
      search: '',
      table: {
        columns: [
          {
            title: 'name',
            value: 'name',
            type: 'text',
            width: '70%'
          },
          {
            title: 'type',
            value: 'type',
            type: 'text',
            width: '30%'
          },
        ],
        rows: []
      },
    }
  },

  computed: {
    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData
      return t
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      console.log(this.$options.name, 'statusSubscribe', 'data', this.data)
      this.reset()
      this.statusUnsubscribe(this.$options.name || 'LOCATION_CONNECTIONS_MODAL')
      this.prepareTable()
    },

    async prepareTable(): Promise<void> {
      try {
        if (!this.data.brefs?.length) return
        
        this.loader = true
        this.data.brefs.forEach((bref: BrefItem) => {
          if (bref.ref && bref.ref === 'connection') {
            this.table.rows.push(bref)
          }
        })
        
        console.log(this.$options.name, 'prepareTable', 'this.table', this.table)
        this.loader = false
        this.statusSubscribe(this.table.rows, this.$options.name || 'LOCATION_CONNECTIONS_MODAL')
      } catch (err) {
        console.error('CATCH', this.$options.name, 'prepareTable', err)
        this.loader = false
      }
    },

    async statusSubscribe(arr: TableRow[], group: string): Promise<void> {
      this.$store.dispatch('measuresSubscribeInit', {
        name: 'addStatus',
        group: group,
        listener: 'status'
      })
      
      if (arr.length) {
        arr.forEach((item: TableRow) => {
          if (item.$id) {
            this.$store.dispatch('addStatusKey', item)
          }
        })
        await this.$bridge.subscribe(arr.map(obj => obj.$id))
      }
    },

    subscribeHandler(e: { $id?: string; [key: string]: any }): void {
      if (e.$id) {
        this.$store.dispatch('addStatus', e)
      }
    },

    statusUnsubscribe(group: string): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },

    reset(): void {
      this.table.rows = []
    }
  }
})
</script>

<style scoped lang="less">

</style>
